export const NO_REASON = '';
export const INAPPROPRIATE_IMAGE = 'Your uploaded image is inappropriate';
//export const NOT_CELEBRITY = 'Your suggested person is not a celebrity';
export const INCOMPLETE_INCORRECT_INFO =
  'Fill the information completely and correctly';
export const DUPLICATE_CELEBRITY =
  'Your suggested person has already been suggested';
export const OTHER = 'Your social media account must be public';
